import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { noop } from 'lodash';

import { ResendEmailForm } from '../ResendEmailForm';

export const ResendVerificationLinkPage: FC = () => {
  const { $t } = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'resendVerificationLink.title',
            defaultMessage: 'Resend verification link - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <ResendEmailForm
        title={$t({
          id: 'preregistration.resendVerificationLink',
          defaultMessage: 'Resend verification link',
        })}
        subtitle={$t({
          id: 'preregistration.youCanResendVerificationLink',
          defaultMessage:
            'You can resend the verification link using the button below.',
        })}
        onSubmit={noop}
      />
    </>
  );
};
